import { $api } from "@/utils/fetch.ts";

// Organization Queries and Mutations
export const organizationsQueryOptions = (emailToken: string) =>
	$api.queryOptions("get", "/api/orgs", {
		params: {
			query: {
				emailToken,
			},
		},
	});

export const organizationQueryOptions = () =>
	$api.queryOptions("get", "/api/orgs/current");

export const organizationsStatsQueryOptions = () =>
	$api.queryOptions("get", "/api/orgs/stats");

export const useCreateOrganizationMutation = () =>
	$api.useMutation("post", "/api/orgs");

export const useUpdateOrganizationMutation = () =>
	$api.useMutation("put", "/api/orgs/current");

export const useUpdateComplianceMutation = () =>
	$api.useMutation("put", "/api/orgs/update-compliance");

export const useUpdateUnoMutation = () =>
	$api.useMutation("put", "/api/orgs/update-uno");

export const useUpdateMicrosoftTenantMutation = () =>
	$api.useMutation("put", "/api/orgs/update-microsoft-tenant");

export const useUpdateAgentPolicyMutation = () =>
	$api.useMutation("put", "/api/orgs/update-agent-policy");

/** Admin only: the agents switching on unattended irreversible actions would reactivate. */
export const unattendedDestructiveAgentsQueryOptions = () =>
	$api.queryOptions(
		"get",
		"/api/orgs/current/agent-policy/unattended-destructive-agents",
	);
